<template lang="pug">
  .icon-trio
    .icon-intile
      img.tile-icon-shadow(:src="iconSrc")
    Message(
      :title="title"
      :subtitle="text"
      :fontSizes="[20, 16]"
    )
</template>

<script type="text/javascript">
import Message from '@/components/Shared/Message.vue'

export default {
  name: 'IconTrio',
  components: {
    Message
  },
  computed: {
    iconSrc () {
      return require(`@/assets/imagesnew/${this.icon}`)
    }
  },
  props: {
    title: {
      type: String,
      default: 'Focus on leveraging data available online'
    },
    text: {
      type: String,
      default: 'Focus on leveraging data available online'
    },
    icon: {
      type: String,
      default: 'online-data.jpg'
    }
  }
}
</script>

<style scoped lang="scss">
.icon-trio {
  height: 353px;
  max-width: 367px;
  background: #FFFFFF;
  box-shadow: 8px 9px 55px rgba(118, 127, 134, 0.07);
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 38px 10px;
  margin: 12px auto;
}
</style>